import { render, staticRenderFns } from "./TheProjectEstimatedTurnoverByYear.vue?vue&type=template&id=a2aa1e14&"
import script from "./TheProjectEstimatedTurnoverByYear.vue?vue&type=script&lang=js&"
export * from "./TheProjectEstimatedTurnoverByYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports